var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcuseXml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20764 7.97851L10.2583 10.1152L11.309 7.97851H13.0749L11.2825 11.1659L13.1234 14.4062H11.3399L10.2583 12.2298L9.17673 14.4062H7.3888L9.23412 11.1659L7.43736 7.97851H9.20764Z",
    fill: "#093C5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56026 2.89158H17.7317L17.7317 17.2266H17.7401V20.9219C18.989 20.9179 20 20.0235 20 18.9209V2.89158C20 1.78648 18.9845 0.890625 17.7317 0.890625H2.56026C1.30753 0.890625 0.291992 1.78649 0.291992 2.89158V18.9209C0.291992 20.026 1.30753 20.9219 2.56026 20.9219H11.277V18.9209L2.56026 18.9209V2.89158Z",
    fill: "#093C5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6853 21.5273H16.6253V18.194C16.6253 17.8273 16.3253 17.5273 15.9587 17.5273H13.292C12.9253 17.5273 12.6253 17.8273 12.6253 18.194V21.5273H11.5653C10.972 21.5273 10.672 22.2473 11.092 22.6673L14.152 25.7273C14.412 25.9873 14.832 25.9873 15.092 25.7273L18.152 22.6673C18.572 22.2473 18.2787 21.5273 17.6853 21.5273Z",
    fill: "#093C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcuseXml);
export default __webpack_public_path__ + "static/media/AcuseXML.375804bcb4e59748822fa2286edf7d49.svg";
export { ForwardRef as ReactComponent };